import ShareIcon from './icons/ShareIcon';
import useToast from '../contexts/useToast';

const ShareButton = () => {
  const { showToast } = useToast();

  const handleClick = () => {
    // Strip view param from URL for cleaner share links
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.delete('view');
    const url = urlObj.toString();
    navigator.clipboard.writeText(url).then(
      () => {
        showToast('Link copied!', 'success');
      },
      () => {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        textarea.style.top = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        showToast('Link copied!', 'success');
      }
    );
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{
        border: 'none',
        background: 'transparent',
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        touchAction: 'manipulation',
        WebkitTapHighlightColor: 'transparent',
        minWidth: '44px',
        minHeight: '44px',
      }}
      aria-label="Copy link"
    >
      <ShareIcon size={24} color="var(--accent)" />
    </button>
  );
};

export default ShareButton;
